import { IAntibodyScreening, IAntibodyScreeningResult, IFileUpload, IRecipientProfileRecords } from '@nkr/models/index';

interface IState {
    data: IRecipientProfileRecords,
    antibodyScreenings: IAntibodyScreening[]
    hash: string,
    showOrder: boolean,
    files: IFileUpload[],
    details: {
        show: boolean,
        data: IAntibodyScreeningResult[]
    },
}

const initialState: IState = {
    files: [],
    data: null,
    hash: '',
    antibodyScreenings: [],
    showOrder: false,
    details: {
        show: false,
        data: null
    },
};

const recordsReducer = (state: IState, action): IState => {
    if (action.type == 'afterLoad') {
        return {
            ...state,
            data: action.value.data,
            antibodyScreenings: action.value.screenings,
        };
    }

    if (action.type == 'updateHash') {
        return { ...state, hash: action.value };
    }

    if (action.type == 'updateData') {
        return { ...state, data: action.value };
    }

    if (action.type == 'updateFiles') {
        return { ...state, files: action.value };
    }

    if (action.type == 'viewDetails') {
        return { ...state, details: action.value };
    }

    return { ...state };
};

export {
    IState, initialState,
    recordsReducer
};